export default "__VITE_ASSET__COD_nYnk__"